module.exports = __webpack_public_path__ + "img/award (6).2d657e8e.jpg";